import { interpret } from '@fingermarkglobal/utilities';
import { couponMachine as machine } from './machines/coupon-machine';
import { CreateCouponMachineProps } from './types';

type GetCouponProductsProps = CreateCouponMachineProps & {
  transition?: () => void;
};

const getCouponProducts = ({
  couponNumber,
  coupons,
  transition,
  settings,
  payload,
}: GetCouponProductsProps) => {
  const { run, instance: couponStateMachine } = interpret({
    name: 'couponMachine',
    machine,
    transition,
    payload,
  });

  run({ event: 'GET', config: { couponNumber, coupons, settings, payload } });

  return { couponStateMachine };
};

export { getCouponProducts };
